
export default class Color
{
    private static _opacity = '0.6';
    private static _grayOpacity = '0.6';

    public static DarkThemePastelColors: string[] = [
        `rgba(255, 182, 193, ${Color._opacity})`, // Light Pink | Bad Color
        `rgba(135, 206, 250, ${Color._opacity})`, // Light Sky Blue | Good Color
        `rgba(240, 230, 140, ${Color._opacity})`, // Khaki
        `rgba(144, 238, 144, ${Color._opacity})`, // Light Green
        `rgba(221, 160, 221, ${Color._opacity})`, // Plum
        `rgba(255, 228, 196, ${Color._opacity})`, // Bisque
        `rgba(255, 239, 213, ${Color._opacity})`, // Papaya Whip
        `rgba(255, 192, 203, ${Color._opacity})`, // Pink
        `rgba(250, 250, 210, ${Color._opacity})`, // Light Goldenrod Yellow
        `rgba(175, 238, 238, ${Color._opacity})`, // Pale Turquoise
        `rgba(240, 128, 128, ${Color._opacity})`, // Light Coral
        `rgba(211, 211, 211, ${Color._opacity})`, // Light Gray
        `rgba(245, 222, 179, ${Color._opacity})`, // Wheat
        `rgba(255, 218, 185, ${Color._opacity})`, // Peach Puff
        `rgba(216, 191, 216, ${Color._opacity})`, // Thistle
        `rgba(230, 230, 250, ${Color._opacity})`, // Lavender
        `rgba(255, 250, 240, ${Color._opacity})`, // Floral White
        `rgba(240, 255, 255, ${Color._opacity})`, // Azure
        `rgba(245, 245, 220, ${Color._opacity})`, // Beige
        `rgba(255, 228, 225, ${Color._opacity})`, // Misty Rose
        `rgba(253, 245, 230, ${Color._opacity})`, // Old Lace
        `rgba(255, 255, 240, ${Color._opacity})`, // Ivory
        `rgba(245, 245, 245, ${Color._opacity})`, // White Smoke
        `rgba(250, 240, 230, ${Color._opacity})`, // Linen
        `rgba(240, 248, 255, ${Color._opacity})`, // Alice Blue
        `rgba(255, 240, 245, ${Color._opacity})`, // Lavender Blush
        `rgba(255, 245, 238, ${Color._opacity})`, // Seashell
        `rgba(240, 255, 240, ${Color._opacity})`, // Honeydew
        `rgba(255, 228, 181, ${Color._opacity})`, // Moccasin
        `rgba(255, 250, 205, ${Color._opacity})`  // Lemon Chiffon
    ];

    public static LightThemePastelColors: string[] = [
        `rgba(255, 105, 140, ${Color._opacity})`, // Light Pink -> Darker Pink  | Bad Color
        `rgba(70, 130, 180, ${Color._opacity})`, // Light Sky Blue -> Steel Blue  | Good Color
        `rgba(189, 183, 107, ${Color._opacity})`, // Khaki -> Dark Khaki
        `rgba(50, 205, 50, ${Color._opacity})`, // Light Green -> Lime Green
        `rgba(186, 85, 211, ${Color._opacity})`, // Plum -> Medium Orchid
        `rgba(222, 184, 135, ${Color._opacity})`, // Bisque -> Burly Wood
        `rgba(255, 165, 79, ${Color._opacity})`, // Papaya Whip -> Sandy Brown
        `rgba(255, 105, 180, ${Color._opacity})`, // Pink -> Hot Pink
        `rgba(238, 232, 170, ${Color._opacity})`, // Light Goldenrod Yellow -> Pale Goldenrod
        `rgba(72, 209, 204, ${Color._opacity})`, // Pale Turquoise -> Medium Turquoise
        `rgba(240, 128, 128, ${Color._opacity})`, // Light Coral (no change, already intense)
        `rgba(169, 169, 169, ${Color._opacity})`, // Light Gray -> Dark Gray
        `rgba(210, 180, 140, ${Color._opacity})`, // Wheat -> Tan
        `rgba(255, 160, 122, ${Color._opacity})`, // Peach Puff -> Light Salmon
        `rgba(147, 112, 219, ${Color._opacity})`, // Thistle -> Medium Purple
        `rgba(138, 43, 226, ${Color._opacity})`, // Lavender -> Blue Violet
        `rgba(253, 245, 230, ${Color._opacity})`, // Floral White (no change)
        `rgba(224, 255, 255, ${Color._opacity})`, // Azure -> Light Cyan
        `rgba(245, 222, 179, ${Color._opacity})`, // Beige (no change)
        `rgba(255, 192, 203, ${Color._opacity})`, // Misty Rose (no change)
        `rgba(255, 228, 196, ${Color._opacity})`, // Old Lace -> Bisque
        `rgba(255, 255, 224, ${Color._opacity})`, // Ivory -> Light Yellow
        `rgba(211, 211, 211, ${Color._opacity})`, // White Smoke -> Light Gray
        `rgba(245, 222, 179, ${Color._opacity})`, // Linen -> Wheat
        `rgba(173, 216, 230, ${Color._opacity})`, // Alice Blue -> Light Blue
        `rgba(255, 182, 193, ${Color._opacity})`, // Lavender Blush -> Light Pink
        `rgba(255, 160, 122, ${Color._opacity})`, // Seashell -> Light Salmon
        `rgba(144, 238, 144, ${Color._opacity})`, // Honeydew -> Light Green
        `rgba(255, 165, 0, ${Color._opacity})`, // Moccasin -> Orange
        `rgba(250, 250, 140, ${Color._opacity})`  // Lemon Chiffon -> Yellow
    ];



 public static DarkThemeGrayColors: string[] = [
    `rgba(230, 235, 255, ${Color._grayOpacity})`, // Muito claro (quase branco azulado)
    `rgba(130, 165, 240, ${Color._grayOpacity})`, // Azul pastel médio
    `rgba(110, 155, 225, ${Color._grayOpacity})`, // Azul médio mais forte
    `rgba(70, 115, 200, ${Color._grayOpacity})`,  // Azul pastel escuro
];

public static LightThemeGrayColors: string[] = [
    `rgba(40, 80, 180, ${Color._grayOpacity})`,   // Azul marinho pastel escuro
    `rgba(100, 140, 220, ${Color._grayOpacity})`,  // Azul médio
    `rgba(150, 190, 240, ${Color._grayOpacity})`, // Azul claro
    `rgba(215, 235, 255, ${Color._grayOpacity})`, // Azul muito claro
];



    
    public static GoodColorIndex = 1;
    public static BadColorIndex = 0;
   
    
}